// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--gQodA","wrapper":"a10a3f92e9--wrapper--Ycswz","collapse-button":"a10a3f92e9--collapse-button--Sd2lE"};